var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "with-border" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.payable.type === "orders"
          ? _c("h2", { staticClass: "m-0 ml-20 keep-all" }, [
              _vm._v("Finalizar compra")
            ])
          : _c("h2", { staticClass: "m-0 ml-20" }, [_vm._v("Pagar Assinatura")])
      ]),
      _vm._v(" "),
      _vm.payable.type === "cycles"
        ? _c("div", { staticClass: "pricing float text-right" }, [
            _c("span", { staticClass: "price" }, [
              _vm._v(_vm._s(_vm._f("intToCurrency")(_vm.payable.amount.total)))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.payable.type === "orders"
        ? _c("countdown", {
            attrs: { initialTime: _vm.payable.created_at },
            on: {
              timeIsUp: function($event) {
                _vm.timeIsUp()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", { staticClass: "cart", attrs: { src: "/static/carrinho.svg" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93000918", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93000918","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Payment/Header.vue
// module id = null
// module chunks = 